import { NpvrEventItem } from '@smart-tv/typings/npvr';

import { kmm } from './kmm';
import { mapNpvrEvent } from './npvr-helpers';

export async function getRecordedNpvrEvents(): Promise<NpvrEventItem[]> {
  const events = await kmm((repo) => repo.getRecordedNpvrEvents());

  return events.asJsReadonlyArrayView().map(mapNpvrEvent);
}

export default getRecordedNpvrEvents;
